import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useAlert, Spin, Badge, DataTable, SearchInput, ImagePreview, FormDrawer, InfoBar, PageHeader, TableStatusBar } from '../ui';
import { DataTableColumn } from '../ui/DataTable';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import User from '../../Models/User';
import datas from "../../Assets/data.json";
import env from 'react-dotenv';
import { Crypter } from '../../Functions/Security/Crypter';
import UpdateUser from './Buttons/UpdateUser';
import BlockDeblockUser from './Buttons/BlockDeblockUser';
import AddUser from './Buttons/AddUser';
import FormUserUpdate from './Forms/FormUserUpdate';

export default function GestionUser() {
    // USER TOKEN
    const authHeader = useAuthHeader()
    // USER SESSION
    const auth = useAuthUser()
    const user: User = JSON.parse(JSON.stringify(auth() || {}))
    const alert = useAlert()

    const [data, setData] = useState([])

    const [arrierePlan, setArrierePlan] = useState([])
    const [arrierePlanSelected, setArrierePlanSelected] = useState<any>()

    const [dataTri, setDataTri] = useState<any>([])

    const [loading, selLoading] = useState(false)
    const [textRes, setTextRes] = useState("")

    useEffect(() => {
        LoadData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function Search(search: string) {
        if (search.length == 0) {
            LoadData()
        }
        else {
            selLoading(true)
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: env.API_BASE_URL + datas.API_LINKs.GetFilialeBy + Crypter.encrypt(search),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': authHeader(),
                }
            };
            console.log(Crypter.encrypt(search))

            axios.request(config)
                .then((response: any) => {
                    const res = JSON.parse(Crypter.decrypt(response.data)).Value
                    if (res.StatutCode == 200) {
                        selLoading(false)

                        const users: any = []
                        const ap: any = []

                        res.Result.map((data: any) => {
                            if (data.Statut != 2) {
                                users.push({ id: data.CodeU, CodeU: data.CodeU, Image: data.Image, Name: data.Name, Prenom: data.Prenom, Mobile: data.Mobile, Service: data.CodeS, Statut: data.Statut, Actions: data.CodeU, Email: data.Email, CodeFiliale: data.CodeFiliale }
                                )
                                ap.push({ id: data.CodeU, ModifDate: data.ModifDate, UpdateCount: data.UpdateCount, CreatedBy: data.CreatedBy, ExpiredSession: data.ExpiredSession, ExpiredDate: data.ExpiredDate })
                            }
                        })

                        setDataTri(users)
                        setArrierePlan(ap)


                    }
                    else {
                        selLoading(false)
                        setDataTri([])
                        setTextRes("")
                        alert.warning(res.Message)
                    }
                })
                .catch((error: any) => {
                    setTextRes("")
                    alert.error('Error', error)
                    selLoading(false)
                    console.log(error);
                });
        }

    }
    function LoadData() {
        const codeAbonne = user.CodeAbonne
        selLoading(true)
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.GetAllUser + Crypter.encrypt(codeAbonne),
            headers: {
                'Accept': 'text/plain',
                'Authorization': authHeader(),
            }
        };

        axios.request(config)
            .then((response: any) => {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value
                if (res.StatutCode == 200) {
                    selLoading(false)

                    const users: any = []
                    const ap: any = []

                    res.Result.map((data: any) => {
                        if (data.Statut != 2) {
                            users.push({ id: data.CodeU, CodeU: data.CodeU, Image: data.Image, Name: data.Name, Prenom: data.Prenom, Mobile: data.Mobile, RoleId: data.RoleId, CodeS: data.CodeS, DateCreated: data.DateCreated, Statut: data.Statut, Actions: data.CodeU, Email: data.Email, CodeFiliale: data.CodeFiliale }
                            )
                            ap.push({ id: data.CodeU, ModifDate: data.ModifDate, UpdateCount: data.UpdateCount, CreatedBy: data.CreatedBy, ExpiredSession: data.ExpiredSession, ExpiredDate: data.ExpiredDate })
                        }
                    })

                    setDataTri(users)
                    setArrierePlan(ap)


                }
                else {
                    selLoading(false)
                    setDataTri([])
                    //localStorage.setItem("tabGuichet", JSON.stringify([]))
                    setTextRes("")
                    alert.warning(res.Message)
                }
            })
            .catch((error: any) => {
                setTextRes("")
                alert.error('Error', error)
                selLoading(false)
                console.log(error);
            });
    }

    function tri(type: string) {

        var dte: any[] = []
        if (type == "a") {
            dte = data
        } else {
            data.map((el: any) => {
                if (el.Statut == type) {
                    dte.push(el)
                }
            })

        }
        setDataTri(dte)

        setTextRes(dte.length + " Resultat(s) obtenu")

    }
    const columns: DataTableColumn[] =
        [
            {
                field: 'Image', headerName: 'Photo de Profile', width: 70, renderCell: ({ value }) => (
                    <ImagePreview
                        src={value}
                        width={40}
                        height={40}
                        className="rounded-md"
                    />
                ),
            },
            { field: 'CodeU', headerName: 'Code utilisateur', width: 100 },
            { field: 'Name', headerName: 'Nom', width: 150 },
            { field: 'Prenom', headerName: 'Prénom', width: 150 },
            { field: 'Mobile', headerName: 'Tel', width: 100 },
            { field: 'RoleId', headerName: 'Groupe', width: 150 },
            { field: 'CodeFiliale', headerName: 'Filiale', width: 150 },
            { field: 'CodeS', headerName: 'Service', width: 150 },
            { field: 'DateCreated', headerName: 'Date création', width: 150 },
            { field: 'Email', headerName: 'Email', width: 150 },
            {
                field: 'Statut', headerName: 'Statut', width: 70, renderCell: ({ value }) => (
                    <Badge color={value == 1 ? "blue" : value == 3 ? "amber" : "red"}>
                        {value == 1 ? "actif" : value == 3 ? "Nouveu" : "bloqué"}
                    </Badge>
                ),
            }
            ,
            {
                field: 'Actions', headerName: 'Actions', width: 150,
                renderCell: ({ value }) => (
                    <div className="flex items-center gap-2">
                        <UpdateUser handleFunction={() => { LoadData() }} user={dataTri.find((ar: any) => (ar.id == value))} />
                        <BlockDeblockUser handleFunction={() => { LoadData() }} user={dataTri.find((ar: any) => (ar.id == value))} />
                    </div>
                ),
            },
        ];

    function handleRowClick(e: any) {
        setArrierePlanSelected(arrierePlan.find((ar: any) => (ar.id == e.id)))
    }

    const [open, setOpen] = useState(false)
    const [users, setUsers] = useState<any>()

    const handleClose = () => {
        setOpen(false);
    };
    return (
        <Spin spinning={loading} >
            <PageHeader
                title="Gestion des utilisateurs"
                subtitle="Paramétrez les comptes, groupes et habilitations"
                actions={<AddUser handleFunction={() => { LoadData() }} />}
            />
            <div className="eb-table-wrap">
                <SearchInput onSearch={Search} size='lg' placeholder='Saisissez pour effectuer une recherche profonde' className="mb-3" />
                <DataTable onRowClick={handleRowClick} rows={dataTri} height={300} columns={columns} searchable />
            </div>
            <TableStatusBar count={dataTri.length} loading={loading} onRefresh={LoadData} />
            <InfoBar data={[
                { label: 'Date Modif', value: arrierePlanSelected?.ModifDate },
                { label: 'Nombre de Modif', value: arrierePlanSelected?.UpdateCount },
                { label: 'Créé par', value: arrierePlanSelected?.CreatedBy },
                { label: 'Date Expiration', value: arrierePlanSelected?.ExpiredDate },
                { label: 'Session expirée ?', value: arrierePlanSelected?.ExpiredSession == 1 ? 'Oui' : 'Non' },
            ]} />

            <FormDrawer
                open={open}
                onClose={handleClose}
                title={`Modification de l'utilisateur ${users?.Name || ''}`}
                hint="Les informations existantes sont pré-remplies. Modifiez les champs souhaités puis enregistrez."
            >
                <FormUserUpdate handleFunction={() => { setOpen(false); LoadData() }} user={users} />
            </FormDrawer>
        </Spin>
    );
}
